/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SubtitleInputs */

const en_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle`)
};

const fr_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titre`)
};

const de_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitolo`)
};

const ru_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitular`)
};

const zh_cn2_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_subtitle = /** @type {(inputs: SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle = /** @type {((inputs?: SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle(inputs)
	if (locale === "de") return de_subtitle(inputs)
	if (locale === "it") return it_subtitle(inputs)
	if (locale === "ru") return ru_subtitle(inputs)
	if (locale === "es") return es_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle(inputs)
	if (locale === "ja") return ja_subtitle(inputs)
	if (locale === "hi") return hi_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle(inputs)
	return en_subtitle(inputs)
});